import React from 'react';
import { compose } from 'redux';
import PageTitle from 'hoc/PageTitle';
import PageTheme from 'hoc/PageTheme';
import DashboardTemplate from 'components/templates/Dashboard';
import HeaderContainer from 'containers/HeaderContainer';
import SideBarContainer from 'containers/SideBarContainer';
import { Grid } from 'react-bootstrap';
import { PageNotFoundTile } from 'components/molecules/ErrorTile';

const NotFound = () => (
    <DashboardTemplate
        header={<HeaderContainer hideLinks={true} />}
        sidebar={<SideBarContainer navItems={[]} />}
        title={<div style={{ height: '112px' }} />}>


        <Grid fluid={true}>
            <PageNotFoundTile />
        </Grid>
    </DashboardTemplate>
);

export default compose(
    PageTitle({ pageTitle: 'Not Found', showGGBranding: false }),
    PageTheme({ themeDefaults: { 'whitelabel.showGGBranding': false } })
)(NotFound);



// WEBPACK FOOTER //
// ./src/components/pages/NotFound.js